module.exports = __webpack_public_path__ + "static/media/Krefty.f42636f4.md";